t = require('app/scripts/views/internal/teacup-with-helpers')('card_detail')
commentOptions = require('app/scripts/views/templates/comment_options')
memberAvatarTemplate = require './member_avatar'
sidebarAction = require 'app/scripts/views/templates/card_detail_sidebar_button'
{ CardBackTestIds } = require '@trello/webdriverio-tests'

sidebarTemplate = t.renderable (data) ->
  { editable, isLoggedIn, isOnBoardTemplate, isSubscribed, cardCoverChooserEnabled, isTemplate } = data
  t.div '.window-sidebar', ->
    # add to card section
    if editable
      t.div '.window-module.suggested-actions-module.js-suggested-actions.hide', ->
        t.div '.suggested-actions-settings.js-suggested-actions-settings', ->
          t.icon 'gear'
        t.h3 '.mod-no-top-margin', ->
          t.format 'suggested'
        t.div '.u-clearfix', ->
          sidebarAction('js-join', 'member', 'join')
        t.a '.suggested-actions-feedback.js-suggested-actions-feedback', { href: '#' }, ->
          t.format 'feedback'

      t.div '.window-module.u-clearfix', ->
        t.h3 '.mod-no-top-margin.js-sidebar-add-heading', ->
          if isTemplate
            t.format 'add-to-template'
          else
            t.format 'add-to-card'
        t.div '.u-clearfix', ->
          if !isOnBoardTemplate
            sidebarAction('js-change-card-members', 'member', 'members')
          sidebarAction('js-edit-labels', 'label', 'labels')
          sidebarAction('js-add-checklist-menu', 'checklist', 'checklist')
          sidebarAction('js-add-due-date', 'clock', 'due-date')
          sidebarAction('js-attach', 'attachment', 'attachment')
          if cardCoverChooserEnabled
           sidebarAction('js-card-cover-chooser', 'card-cover', 'cover')

    t.div '.js-plugin-buttons'

    # actions section
    t.div '.window-module.u-clearfix', ->
      t.h3 '.mod-no-top-margin', ->
        t.format 'actions'

      if isLoggedIn
        t.div '.u-clearfix', ->
          if editable
            # NOTE vote and subscribe buttons will have their content
            # rendered as siblings. This is so that you can tab through buttons (all must be anchor tags)
            sidebarAction('js-move-card', 'move', 'move')
            sidebarAction('js-copy-card', 'copy', 'copy')
            sidebarAction('js-convert-to-template.hide', 'template-card', 'make-template')
            t.span '.js-template-sidebar-button.hide'
            if !isOnBoardTemplate || isSubscribed
              t.span '.js-subscribe-sidebar-button.hide'
            t.span '.js-vote-sidebar-button.hide'
            t.hr()
            sidebarAction('js-archive-card', 'archive', 'archive')
            sidebarAction('js-unarchive-card', 'refresh', 'send-to-board')
            sidebarAction('js-delete-card.hide.negate', 'remove', 'delete')
          else
            sidebarAction('js-copy-card', 'card', 'copy')
            if !isOnBoardTemplate
              t.a '.js-subscribe-sidebar-button.hide', { href: '#' }
            t.a '.js-vote-sidebar-button.hide', { href: '#' }

      sidebarAction('js-more-menu', 'share', 'share')

module.exports = t.renderable (data) ->
  { editable, canComment, me, loading, canToggleDetails, subscribeOnComment,
  isOnBoardTemplate, isSubscribed, ATBDescComponentEnabled, cardCoverChooserEnabled,
  cardCoverIsAttachment } = data

  t.div '.window-cover.hide.js-card-cover-box.js-stickers-area', {
    class: t.classify({
      'js-open-card-cover-in-viewer': cardCoverIsAttachment
    })
  }, ->
    t.div '.window-cover-stickers.js-display-stickers'

    if cardCoverChooserEnabled
      t.div '.window-cover-menu.hide', ->
        t.a '.window-cover-menu-button.js-card-cover-chooser', { href: '#' }, ->
            t.icon 'card-cover'
            t.text ' '
            t.format 'cover'


  t.div '.js-card-banner'

  t.div '.window-header', ->

    t.span '.window-header-icon.icon-lg.icon-card.js-card-header-icon'

    titleClasses =
      'window-title': true

    t.div { class: t.classify(titleClasses) }, ->

      t.h2 '.card-detail-title-assist.js-title-helper', { dir: 'auto' }

      inputClasses =
        'mod-card-back-title': true
        'js-card-detail-title-input': true

      t.textarea { class: t.classify(inputClasses), disabled: !editable, dir: 'auto' }

    t.div '.window-header-inline-content.quiet.js-current-list'
    if !isOnBoardTemplate || isSubscribed
      t.div '.window-header-inline-content.hide.js-subscribed-indicator-header', ->
        t.icon 'subscribe'

  t.div '.window-main-col', ->

    t.div '.card-detail-data.u-gutter', ->

      t.div '.card-detail-item.u-clearfix.hide.js-card-detail-members', ->
        t.h3 '.card-detail-item-header.mod-no-top-margin', ->
          t.format 'members'

        t.div '.js-card-detail-members-list'

      t.div '.card-detail-item.card-detail-item-labels.u-clearfix.hide.js-card-detail-labels', ->
        t.h3 '.card-detail-item-header', ->
          t.format 'labels'

        t.div '.u-clearfix.js-card-detail-labels-list'

      t.div '.card-detail-item.hide.js-card-detail-due-date', ->
        t.h3 '.card-detail-item-header', ->
          t.format 'due-date'

        t.div '.card-detail-due-date-badge.js-card-detail-due-date-badge', ->
          t.span '.card-detail-badge-due-date-complete-box.js-card-detail-due-date-badge-complete', ->
            t.span '.icon-sm.icon-check.card-detail-badge-due-date-complete-icon'
          t.button '.button-link.card-detail-badge-due-date-button', ->
            t.span '.js-date-text.card-detail-due-date-text'
            t.span '.js-due-status.card-detail-due-status-lozenge'

      t.div '.card-detail-item.hide.js-card-detail-votes', ->
        t.h3 '.card-detail-item-header', ->
          t.format 'votes'

        t.a '.card-detail-badge.is-clickable.js-card-detail-votes-badge.js-show-votes', { href: '#' }

      t.div '.card-detail-item.hide.js-card-detail-age', ->
        t.h3 '.card-detail-item-header', ->
          t.format 'last-updated'

        t.div '.card-detail-badge.date.mod-last-updated.js-card-detail-age-badge'

      t.div '.plugin-detail-badges.js-plugin-badges'
      t.div '.u-clearfix'

    if !ATBDescComponentEnabled
      t.div '.window-module', ->

        t.div '.window-module-title.window-module-title-no-divider.card-detail-description', ->
          t.span '.icon-description.icon-lg.window-module-title-icon'
          t.h3 '.u-inline-block', ->
            t.format 'description'
          if editable
            t.div { class: t.classify(editable: editable), attr: 'desc' }, ->
              t.a '.button.subtle.hide-on-edit.js-show-with-desc.js-edit-desc', { href: '#' }, ->
                t.format 'edit'

        t.div '.u-gutter.js-hide-on-minimize-desc', ->
          t.div { class: t.classify(editable: editable), attr: 'desc' }, ->

            t.div '.description-content.js-desc-content', ->
              t.div '.description-content-fade-button', ->
                t.span '.description-content-fade-button-text', ->
                  t.format 'show-full-description'

              t.div '.current.markeddown.hide-on-edit.js-card-desc.js-show-with-desc.hide', { dir: 'auto' }

              if editable
                t.p '.u-bottom.js-hide-on-edit.js-hide-with-desc', ->
                  t.a '.description-fake-text-area.hide-on-edit.js-edit-desc.js-hide-with-draft', { href: '#' }, ->
                    t.format 'add-a-more-detailed-description'

                t.div '.card-detail-edit.edit', ->
                  t.a '.helper.button.subtle.js-format-help', { href: '#' }, ->
                    t.format 'formatting-help'

                  t.textarea '.field.field-autosave.js-description-draft.description.card-detail-description', {
                    placeholder: t.l('add-a-more-detailed-description')
                  }

                t.p '.edits-warning.quiet', ->
                  t.format 'you-have-unsaved-edits-on-this-field'
                  t.text ' '
                  t.a '.js-view-edits', { href: '#' }, ->
                    t.format 'view-edits'
                  t.text " - "
                  t.a '.js-discard-edits', { href: '#' }, ->
                    t.format 'discard'
                t.p '.edits-error.error', ->
                  t.format 'edit-not-saved'
    else
      t.div '.js-fill-card-detail-desc'

    t.div '.window-module.u-clearfix.js-location-section.hide', ->
      t.div '.window-module-title.window-module-title-no-divider', ->
        t.span '.window-module-title-icon.icon-lg.icon-location'
        t.h3 '.u-inline-block', ->
          t.format 'location'

      t.div '.u-gutter', ->
        t.div '.u-clearfix.js-card-location'

    t.div '.window-module.u-clearfix.js-custom-fields-section.hide', ->
      t.div '.window-module-title.window-module-title-no-divider', ->
        t.span '.window-module-title-icon.icon-lg.icon-custom-field'
        t.h3 '.u-inline-block', ->
          t.format 'custom-fields'

      t.div '.u-gutter', ->
        t.div '.u-clearfix.js-custom-field-detail-badges.custom-field-detail-badges'

    t.div '.js-plugin-card-back-sections'

    t.div '.js-plugin-sections'

    t.div '.js-plugin-suggestion-sections'

    t.div '.window-module.js-trello-attachments-section.trello-attachments-section.u-clearfix.hide', ->

      t.div '.window-module-title.window-module-title-no-divider', ->
        t.span '.window-module-title-icon.icon-lg.icon-board'
        t.h3 '.u-inline-block', ->
          t.format 'trello attachments'

      t.div '.u-gutter', ->
        t.div '.u-clearfix.js-trello-attachments-list'

        t.p '.js-show-fewer-trello-attachments.hide', ->
          t.a '.quiet-button.js-view-some-trello-attachments', { href: '#' }, ->
            t.format 'show-fewer-trello-attachments'

        t.p '.js-show-more-trello-attachments.hide', ->
          t.a '.quiet-button.js-view-all-trello-attachments', { href: '#' }

        if editable
          t.p ->
            t.a '.button.subtle.js-attach-trello-attachment', { href: '#' }, ->
              t.format 'add-trello-attachment'

    t.div '.window-module.js-attachments-section.u-clearfix.hide', ->
      t.div '.window-module-title.window-module-title-no-divider', ->
        t.span '.window-module-title-icon.icon-lg.icon-attachment'
        t.h3 '.u-inline-block', ->
          t.format 'attachments'

      t.div '.u-gutter', ->
        t.div '.u-clearfix.js-attachment-list'

        t.p '.js-show-fewer-attachments.hide', ->
          t.a '.quiet-button.js-view-some-attachments', { href: '#' }, ->
            t.format 'show-fewer-attachments'

        t.p '.js-show-more-attachments.hide', ->
          t.a '.quiet-button.js-view-all-attachments', { href: '#' }

        if editable
          t.p '.js-show-with-attachments.hide', ->
            t.a '.button.subtle.js-attach', { href: '#' }, ->
              t.format 'add-an-attachment'

    t.div '.checklist-list.window-module.js-checklist-list.js-no-higher-edits'

    if !isOnBoardTemplate
      t.div '.window-module', ->

        t.div '.window-module-title.window-module-title-no-divider.card-detail-activity', ->
          t.span '.window-module-title-icon.icon-lg.icon-activity'
          t.h3 ->
            t.format 'activity'
          if canToggleDetails

            t.div '.window-module-title-options', ->
              t.span '.editing-members.js-editing-members.hide'
              t.a '.subtle.button.hide.js-show-details', { href: '#' }, ->
                t.format 'show-details'
              t.a '.subtle.button.hide.js-hide-details', { href: '#' }, ->
                t.format 'hide-details'

        if canComment
          t.div '.new-comment.js-new-comment.mod-card-back', ->

            if me
              t.div '.member.member-no-menu', ->
                memberAvatarTemplate(me)

            t.form ->
              t.div '.comment-frame', ->
                t.div '.comment-box', ->
                  t.textarea '.comment-box-input.js-new-comment-input', { placeholder: t.l('write-a-comment-ellipsis'), dir: 'auto' }

                  t.div '.comment-controls.u-clearfix', ->
                    t.input '.primary.confirm.mod-no-top-bottom-margin.js-add-comment', {
                      disabled: 'disabled'
                      type: 'submit'
                      value: t.l('save')
                    }
                    t.span {
                      class: t.classify({
                        'comment-subscribe': true,
                        'is-clickable': true,
                        'is-subscribed': subscribeOnComment,
                        'js-comment-subscribe': true
                      }),
                      'aria-label': t.l('watch-card-for-updates')
                    }, ->
                      t.span '.comment-subscribe-box', ->
                        t.span '.icon-sm.icon-check.comment-subscribe-icon'
                      t.div '.comment-subscribe-description', ->
                        t.format 'watch'

                  commentOptions editable

            t.div '.comment-too-long-warning', ->
              t.p ->
                t.format 'your-comment-is-too-long-you-can-add-it-as-a-text-attachment-or-truncate-it'
              t.input '.primary.js-attach-comment', { type: 'submit', value: t.l('add-as-an-attachment') }
              t.input '.js-truncate-comment', { type: 'submit', value: t.l('truncate') }

        t.div '.js-list-actions.mod-card-back'

        if loading
          t.div '.spinner.loading.js-loading-card-actions'

        t.p '.u-bottom', ->
          t.a '.show-more.hide.js-show-all-actions', { href: '#' }, ->
            t.format 'show-all-actions-ellipsis'

  sidebarTemplate(data)

  t.p '.dropzone', ->
    t.format 'drop-files-to-upload'

  t.p '.dropzone-limited.attachments-per-card', ->
    t.format 'too-many-attachments-on-card'

  t.p '.dropzone-limited.attachments-per-board', ->
    t.format 'too-many-attachments-on-board'

  t.p '.dropzone-restricted.attachments-restricted', ->
    t.format 'attachments-restricted'
